<template>
  <div class="category-container">
    <div class="add-btn-wrapper">
      <el-button class="primary" @click="addCategory">添加分类</el-button>
    </div>
    <div
      v-for="item in categories"
      :key="item.categoryId"
      class="category-item"
    >
      <div class="category-name">{{ item.categoryName }}</div>
      <div class="category-actions">
        <button class="action-btn" @click="onProduct(item.categoryId)">货物</button>
        <button class="action-btn" @click="editCategory(item)">修改</button>
        <button class="action-btn" @click="onDelete(item)">删除</button>
        <label class="switch">
          <input type="checkbox" v-model="item.status" :true-value="1" :false-value="0" @change="onStatusChange(item)" />
          <span class="slider" :class="{ checked: item.status === 1 }"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import adminrequest from '@/utils/adminrequest'

export default {
  name: 'ManageCategory',
  data() {
    return {
      categories: []
    }
  },
  mounted() {
    this.fetchCategories();
  },
  methods: {
    async fetchCategories() {
      const options = {method: 'GET', url: '/admin/manage/product/getCategory'};
      try {
        const response = await adminrequest.request(options);
        const json = response.data;
        if (json.code === 200) {
          this.categories = json.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    onProduct(item) {
      console.log(item)
      this.$router.push({path: '/ManageProduct', query: {itemId: item}});
    },
    onDelete(item) {
      if (confirm('确定删除分类“' + item.categoryName + '”？')) {
        this.categories = this.categories.filter(c => c.categoryId !== item.categoryId);
      }
    },
    async onStatusChange(item) {
      try {
        const options = {
          method: 'POST',
          url: '/admin/manage/product/updateCategory',
          headers: {'content-type': 'application/json'},
          data: {categoryId: item.categoryId, status: item.status}
        };
        
        const response = await adminrequest.request(options);
        if (response.data.code === 200) {
          this.$message({
            type: 'success',
            message: '状态更新成功'
          });
        } else {
          // 回滚状态
          item.status = item.status === 1 ? 0 : 1;
          this.$message({
            type: 'error',
            message: '状态更新失败: ' + response.data.message
          });
        }
      } catch (error) {
        // 回滚状态
        item.status = item.status === 1 ? 0 : 1;
        console.error(error);
        this.$message({
          type: 'error',
          message: '网络错误，请重试'
        });
      }
    },
    addCategory() {
      this.$prompt('请输入分类名称', '添加分类', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{1,20}$/,
        inputErrorMessage: '分类名称不能超过20个字符'
      }).then(({ value }) => {
        this.createCategory(value);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消添加'
        });
      });
    },
    async createCategory(name) {
      try {
        const form = new FormData();
        form.append("categoryName", name);
        
        const options = {
          method: 'POST',
          url: '/admin/manage/product/addCategory',
          headers: {'content-type': 'multipart/form-data'},
          data: form
        };
        
        const response = await adminrequest.request(options);
        if (response.data.code === 200) {
          this.$message({
            type: 'success',
            message: '分类添加成功'
          });
          this.fetchCategories(); // 刷新分类列表
        } else {
          this.$message({
            type: 'error',
            message: '分类添加失败: ' + response.data.message
          });
        }
      } catch (error) {
        console.error(error);
        this.$message({
          type: 'error',
          message: '网络错误，请重试'
        });
      }
    },
    editCategory(item) {
      this.$prompt('请输入新的分类名称', '修改分类', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: item.categoryName,
        inputPattern: /^.{1,20}$/,
        inputErrorMessage: '分类名称不能超过20个字符'
      }).then(({ value }) => {
        if (value === item.categoryName) {
          this.$message({
            type: 'info',
            message: '分类名称未修改'
          });
          return;
        }
        this.updateCategory(item.categoryId, value);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消修改'
        });
      });
    },
    async updateCategory(id, name) {
      try {
        const options = {
          method: 'POST',
          url: '/admin/manage/product/updateCategory',
          headers: {'content-type': 'application/json'},
          data: {categoryId: id, categoryName: name}
        };
        
        const response = await adminrequest.request(options);
        if (response.data.code === 200) {
          this.$message({
            type: 'success',
            message: '分类修改成功'
          });
          this.fetchCategories(); // 刷新分类列表
        } else {
          this.$message({
            type: 'error',
            message: '分类修改失败: ' + response.data.message
          });
        }
      } catch (error) {
        console.error(error);
        this.$message({
          type: 'error',
          message: '网络错误，请重试'
        });
      }
    }
  }
}
</script>

<style scoped>
.category-container {
  padding: 40px 0 0 0;
}
.add-btn-wrapper {
  margin-bottom: 20px;
}
.add-btn {
  padding: 8px 20px;
  border: 1px solid #333;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 16px;
}
.category-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 2px solid #aaa;
  border-radius: 18px;
  margin-bottom: 18px;
  padding: 18px 32px;
  min-width: 500px;
  max-width: 700px;
  font-size: 22px;
}
.category-name {
  flex: 1;
  text-align: left;
}
.category-actions {
  display: flex;
  align-items: center;
  gap: 24px;
}
.category-type {
  font-size: 18px;
  margin-right: 10px;
}
.action-btn {
  background: none;
  border: none;
  color: #222;
  font-size: 18px;
  cursor: pointer;
  margin: 0 4px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 26px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #f44336;
  border-radius: 26px;
  transition: .4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: .4s;
}
input:checked + .slider {
  background-color: #19d66b;
}
input:checked + .slider:before {
  transform: translateX(22px);
}
</style>